import hummaction from '../assets/logo-hummaction.jpeg';
import hummactionHeader from '../assets/hummaction-header-1.jpg';
import cuisine from '../assets/hummaction-cuisine.jpeg';
import repas from '../assets/hummaction-repas.jpeg';
import membres from '../assets/hummaction-membres.jpeg';
import alloMouton from '../assets/allomouton-logo.jpg';
import aldi from '../assets/aldi-logo.png';
import mouton from '../assets/hummaction-mouton.jpeg';
import maraudes from '../assets/hummaction-maraudes.jpeg';

export default {
  hummaction,
  hummactionHeader,
  cuisine,
  repas,
  membres,
  alloMouton,
  aldi,
  mouton,
  maraudes,
};
